import {createSmartAction} from 'redux-smart-actions';

export const getProducts = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/products',
  },
}));
